import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as env from '../../env.json';
import { throwError as observableThrowError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SessionStorageService } from './session-storage.service';

@Injectable({ providedIn: 'root' })
export class EnvironmentService {
  private http = inject(HttpClient);
  private ss = inject(SessionStorageService);

  environment;

  private envVars;

  load() {
    this.loadSettings();
  }

  get() {
    // let environment = this.ss.get('env');
    if (!this.environment) {
      this.loadSettings();
      // this.environment = this.ss.get('env');
      return this.environment;
    }

    return this.environment;
  }

  loadSettings() {
    const url = window.location.href;

    return new Promise(resolve => {
      if (!url.includes('localhost')) {
        this.http.get('env.json?v=1.1').subscribe({
          next: envResponse => {
            this.environment = envResponse;
            this.ss.set('env', this.environment);
            resolve(true);
          },
          error: error => {
            resolve(error);
            return observableThrowError(() => error.error || 'Server error');
          },
        });
      } else {
        this.environment = env['default'];
        this.ss.set('env', this.envVars);
        resolve(true);
      }
    });
  }
}
